import React from 'react';
import styled from '@emotion/styled';

import { parseHtml } from '../../helpers';

import { BulletPoint } from '../../../types/types';

import { StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

type Props = {
  points: BulletPoint[];
};

const Ul = styled.ul({
  display: 'grid',
  gap: pxToRem(32),
  gridColumnGap: pxToRem(32),
  gridTemplateColumns: 'repeat(1, 1fr)',
  background: '#F3F3F3',
  justifyContent: 'center',

  [mqBreakpoints.tablet]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridAutoRows: '1fr',
  },

  [mqBreakpoints.desktop]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
});

const Li = styled.li({
  background: 'var(--color-white)',
  listStyleType: 'none',
  padding: `${pxToRem(32)} !important`,
  width: '100%',

  [mqBreakpoints.tablet]: {
    width: pxToRem(327),
  },

  [mqBreakpoints.desktop]: {
    width: pxToRem(364),
  },
});

const H3 = styled.h3({
  paddingBottom: pxToRem(16),
});

const P = styled.p({
  fontWeight: 'var(--font-weight-regular)',
  paddingBottom: 0,
});

export const CtaTpSummaryPoints: React.FC<Props> = ({ points }) => {
  if (!(points && points.length)) {
    return null;
  }
  return (
    <Ul className='unstyled' data-testid='mp-product-cta-points'>
      {points?.map((point, i) => (
        <Li key={i}>
          <H3>{point.title}</H3>
          {point.description && <P>{parseHtml(point.description)}</P>}
        </Li>
      ))}
    </Ul>
  );
};
